import { numberWithCommas } from "@/app/components/lib/numberWithCommas/numberWithCommas";
export function formatWithSubscript(inputNumber: number): string {
  if (typeof inputNumber !== "number") {
    throw new Error("Input must be a number");
  }

  const inputString = inputNumber.toString();
  const decimalPart = inputString.split(".")[1];

  if (inputNumber < 1 && inputNumber > 0 && decimalPart && decimalPart.length < 5) {
    return inputNumber.toFixed(4); 
  }
  if (inputNumber > 1 && decimalPart ) {
    return numberWithCommas(inputNumber?.toFixed(2)); 
  }
  if (inputNumber > 1  ) {
    return numberWithCommas(inputNumber?.toFixed(1)); 
  }
  if (inputNumber < 1 && inputNumber > 0 && decimalPart  ) {
    return inputNumber?.toFixed(6);
  }
  if (inputNumber < 0.00001 ) {
    return inputNumber?.toFixed(8);
  }

  if (decimalPart && decimalPart?.match(/^0{5,}/)) {
    const leadingZeros = decimalPart?.match(/^0+/);
    const zeroCount = leadingZeros ? leadingZeros[0].length : 0;

    const significantDigits = decimalPart?.slice(zeroCount)?.slice(0, 4);

    return `0.${decimalPart.slice(0, 1)}<sub>${zeroCount - 1}</sub>${significantDigits}`;
  }

  return inputNumber?.toString();
}